module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiPjxwYXRoIGQ9Ik0xMiAzQTkgOSAwIDEgMCAxMiAyMUE5IDkgMCAxIDAgMTIgM1oiIG9wYWNpdHk9Ii4zIi8+PHBhdGggZD0iTTEzLDE3aC0ydi02aDJWMTd6IE0xMyw5aC0yVjdoMlY5eiIvPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xMiAzQTkgOSAwIDEgMCAxMiAyMUE5IDkgMCAxIDAgMTIgM1oiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/i-icon.svg?data
// module id = Mh9d
// module chunks = 1